<template>
  <b-row align-h="start" align-v="end" class="site-audit__head">
    <b-col col cols="auto">
      <a href="#" class="site-audit__head__back btn btn--link" @click="hideAuditDetail">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.441406 7H13.5582" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.43456 0.583374L0.642807 6.56196C0.580737 6.6167 0.531025 6.68402 0.496974 6.75945C0.462923 6.83488 0.445313 6.9167 0.445312 6.99946C0.445312 7.08222 0.462923 7.16403 0.496974 7.23946C0.531025 7.31489 0.580737 7.38222 0.642807 7.43696L7.43456 13.4167" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{$t('audits.backtooverview')}}
      </a>
    </b-col>
  </b-row>
</template>
<script>
import { mapMutations } from 'vuex'

export default {
  name: 'AuditHead',

  methods: {
    ...mapMutations('audit', [
      'hideAuditDetail'
    ])
  }
}
</script>
